import { UserRole } from "../enums/User/UserRole";

export default class Authentication {
  private _id: string;
  private _email: string;
  private _role: UserRole;
  private _token: string;

  constructor(id: string, email: string, role: UserRole, token: string) {
    this._id = id;
    this._email = email;
    this._role = role;
    this._token = token;
  }

  get id(): string {
    return this._id;
  }

  get email(): string {
    return this._email;
  }

  get role(): UserRole {
    return this._role;
  }

  get token(): string {
    return this._token;
  }
}
